//LOGIN
export const POST_LOGIN = "https://allianzsun.zuzzuu.com:17777/login";
//PROFILE
export const POST_CHANGE_PASSWORD = "https://allianzsun.zuzzuu.com:15555/changepassword";
